import React from "react";
import { StageIcons } from "../../../Utils/Constants";
import { components } from "react-select";

export default function SingleStageMenuList(props) {
  const { options, setValue } = props;

  const child = (option) => {
    if (StageIcons[option.value]) {
      return <img src={StageIcons[option.value]} alt="type" />;
    }
    return option.label;
  };

  return (
    <components.MenuList {...props}>
      {options.map((option, i) => (
        <div
          key={i}
          className="stage-menu-item"
          onClick={() => {
            setValue(option);
          }}
        >
          {child(option)}
        </div>
      ))}
    </components.MenuList>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Brand/components/SingleStageMenuList.js